import {
  readSessionCookie,
  writeSessionCookie
} from "@/src/common/utils/sessionCookie"
import { HIDE_PROFILE_COMPLETION_PROMPT } from "@/src/sb/constants"

const DISMISSED = "true"

export const isProfileCompletionPromptDismissed = (): boolean => {
  if (readSessionCookie(HIDE_PROFILE_COMPLETION_PROMPT) === DISMISSED) {
    return true
  }

  try {
    return (
      window.sessionStorage.getItem(HIDE_PROFILE_COMPLETION_PROMPT) ===
      DISMISSED
    )
  } catch {
    return false
  }
}

export const rememberProfileCompletionPromptDismissed = () => {
  writeSessionCookie(HIDE_PROFILE_COMPLETION_PROMPT, DISMISSED)

  try {
    window.sessionStorage.setItem(HIDE_PROFILE_COMPLETION_PROMPT, DISMISSED)
  } catch {
    return
  }
}
